import React, {useState, useEffect} from 'react';
import {EditOutlined, MenuFoldOutlined, MenuUnfoldOutlined} from '@ant-design/icons';
import './index.css'
import {Image, message, Dropdown, Modal, Button, Tooltip} from "antd";
import {delHistoryMessages, delChat, getAllContextMeta} from '../../api/other'
import {useDispatch, useSelector} from "react-redux";
import Os0App from '../../pages/Home/Index/setting'
import Os1App from '../../pages/Home/Translate/setting'
import Os2App from '../../pages/Home/ErrorCorrection/setting'
import Os3App from '../../pages/Home/Analysis/setting'
import Os4App from '../../pages/Home/Chat/setting'
import {setAllContextMeta, setLeftIndex} from "../../store/modules/user";
//头部组件
const HeaderApp =(props)=>{
    const {collapsedLeft,setCollapsedLeft,collapsedRight,setCollapsedRight,homePageIndex,setHomePageIndex,setClearContent} = props
    const [title,setTitle] = useState(null)
    var {userInfo,allContextMeta,leftIndex} = useSelector(state => state.user)
    const dispatch = useDispatch()
    const [items,setItems] = useState([])
    useEffect(()=>{
        if(homePageIndex===0){
            setTitle('灵问词典')
        }else if(homePageIndex===1){
            setTitle('全面翻译')
        }else if(homePageIndex===2){
            setTitle('语法纠错')
        }else if(homePageIndex===3){
            setTitle('语法分析')
        }else if(homePageIndex===4){
            setTitle(allContextMeta.chat_meta[parseInt(leftIndex)].context_title)
        }else if(homePageIndex===9){
            setTitle('LLM预付卡')
        }
        let item = []
        // chat聊天模式 可删除语境
        if(homePageIndex===4){
            item = [{ key: '1', label: ( <span onClick={handleOpenSetting}>语境设置</span> ), },
                { key: '2', label: ( <span onClick={handleDelChat}>删除语境</span> )}]
        }else{
            item = [{ key: '1', label: ( <span onClick={handleOpenSetting}>语境设置</span> ), }]
        }
        setItems([...item])
        localStorage.setItem('ai-chat-homePageIndex',homePageIndex)
    },[homePageIndex])
    useEffect(()=>{
        if(homePageIndex===4){
            setTitle(allContextMeta.chat_meta[parseInt(leftIndex)].context_title)
        }
    },[leftIndex,allContextMeta])

    const [os0,setOs0] = useState(false)
    const [os1,setOs1] = useState(false)
    const [os2,setOs2] = useState(false)
    const [os3,setOs3] = useState(false)
    const [os4,setOs4] = useState(false)
    const handleOpenSetting = ()=>{
        if(!userInfo) return message.error('请先登录！')
        if(homePageIndex===0){
            setOs0(true)
        }else if(homePageIndex===1){
            setOs1(true)
        }else if(homePageIndex===2){
            setOs2(true)
        }else if(homePageIndex===3){
            setOs3(true)
        }else if(homePageIndex===4){
            setOs4(true)
        }
    }
    const handleOs0Ok = ()=>{ //分析确定后 根据修改的配置 来设置展示信息
        setOs0(false)
    }
    const handleOs1Ok = ()=>{ //分析确定后 根据修改的配置 来设置展示信息
        setOs1(false)
    }
    const handleOs2Ok = ()=>{ //分析确定后 根据修改的配置 来设置展示信息
        setOs2(false)
    }
    const handleOs3Ok = ()=>{ //分析确定后 根据修改的配置 来设置展示信息
        setOs3(false)
    }
    const handleOs4Ok = ()=>{
        setOs4(false)
    }
    const handleCloseSetting = ()=>{
        setOs0(false)
        setOs1(false)
        setOs2(false)
        setOs3(false)
        setOs4(false)
    }
    const handleSetHomePageIndex = ()=>{
        localStorage.setItem('ai-chat-homePageIndex',(localStorage.getItem('ai-chat-his-homePageIndex')||0))
        setHomePageIndex(parseInt(localStorage.getItem('ai-chat-his-homePageIndex')))
    }
    const handleDel = ()=>{
		if(!userInfo||!allContextMeta){
			message.error('请先登录！')
			return false
		}
		const {dictionary_meta,translating_meta,correcting_meta,analysis_meta,chat_meta} = allContextMeta
        let context_id = "";
        if(homePageIndex===0) context_id = dictionary_meta.context_id
        if(homePageIndex===1) context_id = translating_meta.context_id
        if(homePageIndex===2) context_id = correcting_meta.context_id
        if(homePageIndex===3) context_id = analysis_meta.context_id
        if(homePageIndex===4) context_id = chat_meta[parseInt(localStorage.getItem('ai-chat-left-index'))].context_id
        delHistoryMessages({context_id}).then(res=>{
            if(res.code===200){
                setClearContent(true)
                setTimeout(()=>{
                    setClearContent(false)
                },200)
            }
        })
    }
    //删除语境后 还存在其他语境情况下返回第一个语境，不存在其他语境返回到词典
    const handleDelChat = ()=>{
        if(!userInfo||!allContextMeta){
            message.error('请先登录！')
            return false
        }
        let delContextId = allContextMeta.chat_meta[parseInt(localStorage.getItem('ai-chat-left-index'))].context_id
        delChat({context_id:delContextId}).then(res=>{
            if(res.code===200){
                getAllContextMeta().then(res=>{
                    if(res.code === 200){
                        if(res.data.chat_meta&&res.data.chat_meta.length>0){
                            dispatch(setLeftIndex('0'))
                        }else{
                            dispatch(setLeftIndex('9981'))
                            setHomePageIndex(0)
                        }
                        dispatch(setAllContextMeta(res.data))
                        setTimeout(()=>{window.location.reload()},500)
                    }
                })
            }
        })
    }
    const leftSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 3.00171V21.0017M5 3.00171H19C20.1046 3.00171 21 3.89714 21 5.00171V19.0017C21 20.1063 20.1046 21.0017 19 21.0017H5C3.89543 21.0017 3 20.1063 3 19.0017V5.00171C3 3.89714 3.89543 3.00171 5 3.00171Z" stroke="#627900" stroke-opacity="0.95" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.75 16.2517L13 12.5017L16.75 8.75171L17.625 9.62671L14.75 12.5017L17.625 15.3767L16.75 16.2517Z" fill="#627900" fill-opacity="0.95"/>
                     </svg>`
    const rightSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 3.00171V21.0017M5 3.00171H19C20.1046 3.00171 21 3.89714 21 5.00171V19.0017C21 20.1063 20.1046 21.0017 19 21.0017H5C3.89543 21.0017 3 20.1063 3 19.0017V5.00171C3 3.89714 3.89543 3.00171 5 3.00171Z" stroke="#627900" stroke-opacity="0.95" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15.875 12.5017L13 9.62671L13.875 8.75171L17.625 12.5017L13.875 16.2517L13 15.3767L15.875 12.5017Z" fill="#627900" fill-opacity="0.95"/>
                      </svg>`
    return (
        <div className={'headWrap'}>
            {
                homePageIndex===9?
                    <div>
                        <div className={'headContent'}>
                            {
                                collapsedLeft?<Tooltip placement="bottom" title={collapsedLeft?'展开':'收起'}>
                                    <div onClick={() => {
                                        setCollapsedLeft(!collapsedLeft);
                                        localStorage.setItem('ai-chat-collapsedLeft','open')
                                    }} className={'hover'}
                                         dangerouslySetInnerHTML={{__html: rightSvg}} style={{display:'inline-block',verticalAlign:'-5px',marginRight:'10px'}}></div>
                                    {/*<Button type="text" icon={collapsedLeft ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} onClick={() => setCollapsedLeft(!collapsedLeft)}*/}
                                    {/*        style={{ fontSize: '16px', width: 34, height: 34,color:'#88993d',marginRight:'15px' }} />*/}
                                </Tooltip>:''
                            }

                            <font>{title}</font>
                            <div className={'redoOutlinedBack'}>
                                <Image width={68} onClick={handleSetHomePageIndex} src={require('../../assets/head/ai-chat-back.png')} preview={false}/>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={'headContent'}>
                        {
                            collapsedLeft?<Tooltip placement="bottom" title={collapsedLeft?'展开':'收起'}>
                                <div onClick={() => {
                                    setCollapsedLeft(!collapsedLeft);
                                    localStorage.setItem('ai-chat-collapsedLeft','open')
                                }} className={'hover'}
                                     dangerouslySetInnerHTML={{__html: rightSvg}} style={{display:'inline-block',verticalAlign:'-5px',marginRight:'10px'}}></div>
                                {/*<Button type="text" icon={collapsedLeft ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} onClick={() => setCollapsedLeft(!collapsedLeft)}*/}
                                {/*        style={{ fontSize: '16px', width: 34, height: 34,color:'#88993d',marginRight:'15px' }} />*/}
                            </Tooltip>:''
                        }
                        <font>{title}</font>
                        <Tooltip placement="bottom" title={'编辑'}>
                        <EditOutlined onClick={handleOpenSetting}/>
                        </Tooltip>
                        {
                            collapsedRight?<>
                                <div className={'redoOutlinedP'}>
                                    <Tooltip placement="bottom" title={'清空记录'}>
                                    <Image className={'hover'} onClick={handleDel} width={16} src={require('../../assets/head/head-1.png')} preview={false}/>
                                    </Tooltip>
                                </div>
                                <div className={'redoOutlined22'}>
                                    <Dropdown menu={{ items }} placement="bottomCenter" arrow>
                                        <div className={'lar'}>
                                            <Image width={3} height={12} src={require('../../assets/head/head-2.png')} preview={false}/>
                                        </div>
                                    </Dropdown>
                                </div>
                                <div className={'redoOutlined33'}>
                                    <Tooltip placement="bottom" title={collapsedRight?'展开':'收起'}>
                                        <div onClick={() => {
                                            setCollapsedRight(!collapsedRight);
                                            localStorage.setItem('ai-chat-collapsedRight','open')
                                        }} className={'hover'}
                                             dangerouslySetInnerHTML={{__html: leftSvg}} style={{display:'inline-block',verticalAlign:'-5px',marginRight:'10px'}}></div>
                                        {/*<Button type="text" icon={collapsedRight ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} onClick={() => setCollapsedRight(!collapsedRight)}*/}
                                        {/*        style={{ fontSize: '16px', width: 34, height: 34,color:'#88993d',marginTop:15,marginLeft:5 }} />*/}
                                    </Tooltip>
                                </div>
                            </>:<>
                                <div className={'redoOutlinedN'}>
                                    <Tooltip placement="bottom" title={'清空记录'}>
                                        <Image className={'hover'} onClick={handleDel} width={16} src={require('../../assets/head/head-1.png')} preview={false}/>
                                    </Tooltip>
                                </div>
                                <div className={'redoOutlinedN2'}>
                                    <Dropdown menu={{ items }} placement="bottomCenter" arrow>
                                        <div className={'larN'}>
                                            <Image width={3} height={12} src={require('../../assets/head/head-2.png')} preview={false}/>
                                        </div>
                                    </Dropdown>
                                </div>
                            </>
                        }
                    </div>
            }
            <Modal footer={null} destroyOnClose={true} title="词典设置" open={os0} onCancel={handleCloseSetting} width={360}>
                <Os0App handleOk={handleOs0Ok} handleCloseModel={handleCloseSetting} />
            </Modal>
            <Modal footer={null} destroyOnClose={true} title="翻译设置" open={os1} onCancel={handleCloseSetting} width={360}>
                <Os1App handleOk={handleOs1Ok} handleCloseModel={handleCloseSetting} />
            </Modal>
            <Modal footer={null} destroyOnClose={true} title="纠错设置" open={os2} onCancel={handleCloseSetting} width={360}>
                <Os2App handleOk={handleOs2Ok} handleCloseModel={handleCloseSetting} />
            </Modal>
            <Modal footer={null} destroyOnClose={true} title="分析设置" open={os3} onCancel={handleCloseSetting} width={360}>
                <Os3App handleOk={handleOs3Ok} handleCloseModel={handleCloseSetting} />
            </Modal>
            <Modal footer={null} destroyOnClose={true} title="语境设置" open={os4} onCancel={handleCloseSetting} width={360}>
                <Os4App handleOk={handleOs4Ok} handleCloseModel={handleCloseSetting} />
            </Modal>

        </div>
    )
}


export default HeaderApp
